import { useQuery, useMutation } from "@tanstack/react-query";
import { UserGoalApi, WeeklyWarmapsApi } from "../../routes/Goals/userGoal";
import { apiLogger } from "../../Utils/logger";

export const useGetReflectionAndTargets = (userGoalId, params) => {
  return useQuery({
    queryKey: ["userGoal", userGoalId, "targetsReflections", params],
    queryFn: async () => {
      try {
        apiLogger.apiRequest(
          "GET",
          `/user/goals/${userGoalId}/targets-reflections`,
          params,
        );
        const response = await UserGoalApi.getTargetsAndReflections(
          userGoalId,
          params,
        );
        apiLogger.apiResponse(
          "GET",
          `/user/goals/${userGoalId}/targets-reflections`,
          response,
          200,
        );
        return response?.data || response;
      } catch (error) {
        apiLogger.apiError(
          "GET",
          `/user/goals/${userGoalId}/targets-reflections`,
          error,
          error.response?.status,
        );
        throw error;
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useGetWeeklyWarmapsQuestions = (params, enabled = true) => {
  return useQuery({
    queryKey: ["weeklyWarmapsQuestions", params],
    queryFn: async () => {
      const response = await WeeklyWarmapsApi.getWeeklyWarmapsQuestions(params);
      return response?.data || response;
    },
    enabled,
    retry: 1,
    staleTime: 0,
    cacheTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useSubmitWeeklyWarmapsAnswers = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const response =
        await WeeklyWarmapsApi.submitWeeklyWarmapsAnswers(payload);
      return response?.data || response;
    },
  });
};
